import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "@material-ui/core/styles";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "./index.css";

import apolloClient from "./apolloClient";
import App from "./App";
import { sagaMiddleware } from "./middleware";
import saga from "./sagas";
import store from "./store";
import { ReactQueryWrappersProvider } from "./shared/react-query-wrappers";
import theme from "./theme/muiTheme";

// Legacy root kept on purpose: React 18 runs in React 17 semantics until we migrate to createRoot.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <ReactQueryWrappersProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ReactQueryWrappersProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById("root"),
);

sagaMiddleware.run(saga);
